import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge"
import liveRoomService from '../services/LiveRoomService';
import authorizeService from './api-authorization/AuthorizeService';
import FixtureDetailsModal from './Modals/FixtureDetailsModal';

import { HubConnectionBuilder } from '@microsoft/signalr';

const CompletedRooms = (props) => {
    const [userRole, setUserRole] = useState(null);
    const [activeUserId, setActiveUserId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [connection, setConnection] = useState(null);

    const [show, setShow] = useState(false);

    const [selectedFixture, setSelectedFixture] = useState(null);
    const [fixtures, setFixtures] = useState(null);

    useEffect(() => {
        if (!userRole) {
            authorizeService.getUser().then((user) => {
                setActiveUserId(user.sub);
                setUserRole(user.role);
            })
        }
    }, []);

    useEffect(() => {
        if (!fixtures) {
            liveRoomService.getCompletedRooms().then((list) => {
                setFixtures(list);
                setLoading(false);
            });
        }
    }, [fixtures]);

    useEffect(() => {
        let getUrl = window.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host;

        const connection = new HubConnectionBuilder()
            .withUrl(`${baseUrl}/hubs/fixturerooms`, {accessTokenFactory: () => authorizeService.getAccessToken()})
            .withAutomaticReconnect()
            .build();

        setConnection(connection);
    }, []);


    const hideModal = () => {
        setShow(false)
    }

    const renderModal = () => {
        if (selectedFixture) {
            return <FixtureDetailsModal
                show={show}
                onHide={hideModal}
                userRole={userRole}
                fixture={selectedFixture}>
            </ FixtureDetailsModal>;
        } else
            return <></>;
    }

    const renderTable = (fixtures) => {

        const content = !fixtures || fixtures.length == 0 ? (
            <tr className="p-2">
                <td colSpan="5" className="text-center">No completed matches</td>
            </tr>
        ) : (fixtures.map((x) => {

            return (<tr key={x.fixtureRoomId}>
                <td>{x.fixtureName}</td>
                <td>{x.dateString}</td>
                <td>{x.endAtString}</td>
                <td>{x.tags ? x.tags.map(x => <Badge key={x.text} className="ml-1"
                                                     variant={x.variant}>{x.text}</Badge>) : []}</td>
                <td>
                    <Button size="sm" variant="outline-primary" onClick={(clickInfo) => {
                        props.history.push(`/scoring/${x.fixtureRoomId}`);
                    }}>Join</Button>

                    <Button size="sm"
                            variant="outline-info"
                            className="ml-2"
                            onClick={async (clickInfo) => {
                                setSelectedFixture(x);
                                setShow(true);
                            }}>Details</Button>

                    <Button size="sm" variant="outline-info" className="ml-2" onClick={(clickInfo) => {
                        props.history.push(`/scoring/${x.fixtureRoomId}/review?roomActive=false`);
                    }}>Review</Button>
                </td>
            </tr>);
        }));

        return (
            <div style={{
                overflowY: 'scroll',
                overflowX: 'scroll',
                whiteSpace: 'nowrap',
                maxHeight: 'calc(100vh - 180px)'
            }}>
                <Table striped bordered hover className="react-bootstrap-table">
                    <thead>
                    <tr>
                        <th>Fixture</th>
                        <th>Fixture Date</th>
                        <th>Ended At</th>
                        <th>Tags</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {content}
                    </tbody>
                </Table>
            </div>
        );
    };

    let contents = loading ? <p><em>Loading...</em></p> : renderTable(fixtures);

    let modal = renderModal();

    return (
        <div>
            <h1 id="tabelLabel">Completed Rooms</h1>
            {contents}

            {modal}
        </div>
    );
}

CompletedRooms.displayName = CompletedRooms.name;

export default CompletedRooms;